import boldIconSvg from '@superdoc/common/icons/bold-solid.svg?raw';
import italicIconSvg from '@superdoc/common/icons/italic-solid.svg?raw';
import underlineIconSvg from '@superdoc/common/icons/underline-solid.svg?raw';
import listIconSvg from '@superdoc/common/icons/list-solid.svg?raw';
import listOlIconSvg from '@superdoc/common/icons/list-ol-solid.svg?raw';
import imageIconSvg from '@superdoc/common/icons/image-solid.svg?raw';
import linkIconSvg from '@superdoc/common/icons/link-solid.svg?raw';
import alignLeftIconSvg from '@superdoc/common/icons/align-left-solid.svg?raw';
import alignCenterIconSvg from '@superdoc/common/icons/align-center-solid.svg?raw';
import alignRightIconSvg from '@superdoc/common/icons/align-right-solid.svg?raw';
import alignJustifyIconSvg from '@superdoc/common/icons/align-justify-solid.svg?raw';
import indentIconSvg from '@superdoc/common/icons/indent-solid.svg?raw';
import outdentIconSvg from '@superdoc/common/icons/outdent-solid.svg?raw';
import paintRollerIconSvg from '@superdoc/common/icons/paint-roller-solid.svg?raw';
import textSlashIconSvg from '@superdoc/common/icons/text-slash-solid.svg?raw';
import rotateLeftIconSvg from '@superdoc/common/icons/rotate-left-solid.svg?raw';
import rotateRightIconSvg from '@superdoc/common/icons/rotate-right-solid.svg?raw';
import calendarCheckIconSvg from '@superdoc/common/icons/calendar-check-solid.svg?raw';
import calendarXmarkIconSvg from '@superdoc/common/icons/calendar-xmark-solid.svg?raw';
import listCheckIconSvg from '@superdoc/common/icons/list-check-solid.svg?raw';
import userEditIconSvg from '@superdoc/common/icons/user-edit-solid.svg?raw';
import eyeIconSvg from '@superdoc/common/icons/eye-solid.svg?raw';
import fileIconSvg from '@superdoc/common/icons/file-solid.svg?raw';
import fontIconSvg from '@superdoc/common/icons/font-solid.svg?raw';
import fileHalfDashedIconSvg from '@superdoc/common/icons/file-half-dashed-solid.svg?raw';
import commentIconSvg from '@superdoc/common/icons/comment-solid.svg?raw';
import circleIconSvg from '@superdoc/common/icons/circle-solid.svg?raw';
import checkIconSvg from '@superdoc/common/icons/check-solid.svg?raw';
import xmarkIconSvg from '@superdoc/common/icons/xmark-solid.svg?raw';
import upRightFromSquareIconSvg from '@superdoc/common/icons/up-right-from-square-solid.svg?raw';
import ellipsisVerticalIconSvg from '@superdoc/common/icons/ellipsis-vertical-solid.svg?raw';
import caretUpIconSvg from '@superdoc/common/icons/caret-up-solid.svg?raw';
import caretDownIconSvg from '@superdoc/common/icons/caret-down-solid.svg?raw';
import rulerSvg from '@superdoc/common/icons/ruler-solid.svg?raw';
import paintbrushSvg from '@superdoc/common/icons/paintbrush-solid.svg?raw';
import highlighterIcon from '@superdoc/common/icons/highlighter-icon.svg?raw';
import magicWandIcon from '@superdoc/common/icons/magic-wand-solid.svg?raw';
import tableIconSvg from '@superdoc/common/icons/table-solid.svg?raw';
import tableColumnsIconSvg from '@superdoc/common/icons/table-columns-solid.svg?raw';
import arrowsLeftRightIconSvg from '@superdoc/common/icons/arrows-left-right-solid.svg?raw';
import arrowsToDotIconSvg from '@superdoc/common/icons/arrows-to-dot-solid.svg?raw';
import plusIconSvg from '@superdoc/common/icons/plus-solid.svg?raw';
import trashIconSvg from '@superdoc/common/icons/trash-can-solid.svg?raw';
import wrenchIconSvg from '@superdoc/common/icons/wrench-solid.svg?raw';
import borderNoneIconSvg from '@superdoc/common/icons/border-none-solid.svg?raw';
import upDownIconSvg from '@superdoc/common/icons/up-down.svg?raw';
import magnifyingGlassSvg from '@superdoc/common/icons/magnifying-glass.svg?raw';
import scissorsIconSvg from '@superdoc/common/icons/scissors-solid.svg?raw';
import copyIconSvg from '@superdoc/common/icons/copy-solid.svg?raw';
import pasteIconSvg from '@superdoc/common/icons/paste-solid.svg?raw';
import strikethroughSvg from '@superdoc/common/icons/strikethrough.svg?raw';

export const toolbarIcons = {
  undo: rotateLeftIconSvg,
  redo: rotateRightIconSvg,
  bold: boldIconSvg,
  italic: italicIconSvg,
  underline: underlineIconSvg,
  color: fontIconSvg,
  link: linkIconSvg,
  image: imageIconSvg,
  alignLeft: alignLeftIconSvg,
  alignRight: alignRightIconSvg,
  alignCenter: alignCenterIconSvg,
  alignJustify: alignJustifyIconSvg,
  bulletList: listIconSvg,
  numberedList: listOlIconSvg,
  indentLeft: outdentIconSvg,
  indentRight: indentIconSvg,
  pageBreak: fileHalfDashedIconSvg,
  copyFormat: paintRollerIconSvg,
  clearFormatting: textSlashIconSvg,
  trackChanges: listCheckIconSvg,
  trackChangesFinal: fileIconSvg,
  trackChangesOriginal: eyeIconSvg,
  trackChangesAccept: calendarCheckIconSvg,
  trackChangesReject: calendarXmarkIconSvg,
  documentMode: userEditIconSvg,
  documentEditingMode: userEditIconSvg,
  documentSuggestingMode: commentIconSvg,
  documentViewingMode: eyeIconSvg,
  colorOption: circleIconSvg,
  colorOptionCheck: checkIconSvg,
  linkInput: linkIconSvg,
  removeLink: xmarkIconSvg,
  openLink: upRightFromSquareIconSvg,
  overflow: ellipsisVerticalIconSvg,
  dropdownCaretUp: caretUpIconSvg,
  dropdownCaretDown: caretDownIconSvg,
  ruler: rulerSvg,
  paintbrush: paintbrushSvg,
  highlight: highlighterIcon,
  ai: magicWandIcon,
  table: tableIconSvg,
  tableActions: tableColumnsIconSvg,
  splitCell: arrowsLeftRightIconSvg,
  mergeCells: arrowsToDotIconSvg,
  addRowBefore: plusIconSvg,
  addRowAfter: plusIconSvg,
  addColumnBefore: plusIconSvg,
  addColumnAfter: plusIconSvg,
  deleteRow: trashIconSvg,
  deleteColumn: trashIconSvg,
  deleteTable: trashIconSvg,
  deleteBorders: borderNoneIconSvg,
  fixTables: wrenchIconSvg,
  lineHeight: upDownIconSvg,
  search: magnifyingGlassSvg,
  cut: scissorsIconSvg,
  copy: copyIconSvg,
  paste: pasteIconSvg,
  strikethrough: strikethroughSvg,
};
